<template>
  <section v-if="!isTopImageLoading" class="top-cover">
    <swiper-container
      slides-per-view="auto"
      :centered-slides="true"
      :loop="true"
      :lazy="true"
      :autoplay="{ delay: delay }"
      :pagination="swiperPagination"
      :navigation="swiperNavigation"
      @swiperrealindexchange="onSlideChange"
    >
      <swiper-slide
        v-for="(topImage, index) in topImages"
        :key="`slide-${index}`"
        class="slide"
      >
        <a :href="topImage.url" @click="onClickSlide">
          <ImgLazy
            :image-url="topImage.imageUrl"
            alt-text="トップページスライド画像"
            aspect-ratio="120 / 63"
            image-class="slide-image"
          />
        </a>
      </swiper-slide>
    </swiper-container>
    <div class="controller">
      <div class="pagination" />
      <div class="navigation">
        <div class="navigation--prev">
          <ChevronBack />
        </div>
        <div
          v-if="!autoPlaySwiper"
          class="navigation--start"
          @click="toggleAutoPlay"
        >
          <SwiperStart />
        </div>
        <div
          v-if="autoPlaySwiper"
          class="navigation--stop"
          @click="toggleAutoPlay"
        >
          <SwiperStop />
        </div>
        <div class="navigation--next">
          <ChevronForward />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import { register } from 'swiper/element/bundle'
import ChevronBack from '../../../atoms/svg_icons/ChevronBack.vue'
import ChevronForward from '../../../atoms/svg_icons/ChevronForward.vue'
import SwiperStart from '../../../atoms/svg_icons/SwiperStart.vue'
import SwiperStop from '../../../atoms/svg_icons/SwiperStop.vue'
import ImgLazy from '../../../atoms/images/ImgLazy.vue'

register()

export default {
  components: { ChevronBack, ChevronForward, SwiperStart, SwiperStop, ImgLazy },
  data() {
    return {
      isTopImageLoading: false,
      topImages: [],
      delay: 3000,
      swiperNavigation: {
        prevEl: '.navigation--prev',
        nextEl: '.navigation--next'
      },
      swiperPagination: {
        el: '.pagination',
        bulletClass: 'pagination-bullet',
        bulletActiveClass: 'pagination-bullet--active',
        clickable: true
      },
      autoPlaySwiper: true
    }
  },
  computed: {
    swiper() {
      return document.querySelector('swiper-container').swiper
    }
  },
  async created() {
    await this.getImages()
    this.pushDataLayer('view_top__top_image')
  },
  methods: {
    async getImages() {
      this.isTopImageLoading = true
      try {
        const res = await axios.get(`/api/v1/pickup/top_images`)
        this.topImages = res.data.data.map(topImage => {
          return {
            id: topImage.attributes.id,
            url: topImage.attributes.url,
            imageUrl: topImage.attributes.image_url
          }
        })
        this.isTopImageLoading = false
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
    },
    onSlideChange() {
      this.pushDataLayer('view_top__top_image')
    },
    onClickSlide() {
      this.pushDataLayer('click_top__top_image')
    },
    pushDataLayer(eventName) {
      const selectedTopImage = this.topImages[this.swiper.realIndex]

      dataLayer.push({
        event: eventName,
        top_image_id: selectedTopImage.id
      })
    },
    toggleAutoPlay() {
      this.autoPlaySwiper = !this.autoPlaySwiper

      if (this.autoPlaySwiper) {
        this.swiper.autoplay.start()
      } else {
        this.swiper.autoplay.stop()
      }
    }
  }
}
</script>
<!-- scopedを設定するとswiperで生成される要素にcssが適用されないので、scopedの設定を外しておく -->
<style lang="scss">
.top-cover {
  padding: 24px 0 0 0;
  width: 100%;
  background-color: $white;

  @media screen and (max-width: ($max-contents-width - 1)) {
    padding: 16px 0 0 0;
  }
}

.slide {
  max-width: 784px;
  width: calc(100% - 32px);
  margin: 0 8px;

  @media screen and (max-width: ($max-contents-width - 1)) {
    margin: 0px 4px;
  }
}

.slide-image {
  border-radius: 8px;
}

.controller {
  height: 24px;
  padding: 24px;
  margin: auto;
  max-width: 780px;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ($max-contents-width - 1)) {
    padding: 16px;
  }
}

.pagination {
  display: flex;
  gap: 8px;
  align-items: center;
}

.pagination-bullet {
  cursor: pointer;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: $gray-2;

  &--active {
    background-color: $gray-1;
  }
}

.navigation {
  display: flex;
  gap: 16px;
  align-items: center;

  &--prev,
  &--next,
  &--start,
  &--stop {
    width: 24px;
    height: 24px;
    fill: $gray-1;
    cursor: pointer;
  }

  &--next {
    //「>」ボタンの右側の空白分で画像の右端からずれるので、右に寄せるようにする
    margin-right: -8px;
  }
}
</style>
